<template>
  <div>

    <div class="content-iframe" style="display: flex;">

      <el-dialog title="杜邦分析" :visible.sync="dubangShow" :modal-append-to-body="false" width="990px">
        <dubang :comCode="comCode"></dubang>
      </el-dialog>

      <el-dialog title="沃尔评分" :visible.sync="wallRatingShow" :modal-append-to-body="false" width="990px">
        <wallRating :comCode="comCode"></wallRating>
      </el-dialog>

      <el-dialog title="Z值模型" :visible.sync="zValueShow" :modal-append-to-body="false" width="990px">
        <zValue :comCode="comCode"></zValue>
      </el-dialog>

      <el-dialog title="M值模型" :visible.sync="mValueShow" :modal-append-to-body="false" width="990px">
        <mValue :comCode="comCode"></mValue>
      </el-dialog>

      <el-dialog title="F值模型" :visible.sync="fValueShow" :modal-append-to-body="false" width="990px">
        <fValue :comCode="comCode"></fValue>
      </el-dialog>

      <el-dialog title="" :visible.sync="anaInfosShow" :modal-append-to-body="false" width="60%">
        <anaInfos v-if="anaInfosShow" :anaType="anaType" :anaData="anaData"></anaInfos>
      </el-dialog>

      <div id="left-menu" class="content-son-box"
        style="width: 190px;height: 100%;margin-right: 10px;position: relative;top: 0px;padding-right: 5px;">
        <div @click="back()" style="height: 30px;display: flex;align-items: center;font-weight: 600;cursor: pointer;">
          <svg xmlns="http://www.w3.org/2000/svg" width="9" height="15" viewBox="0 0 9 15" fill="none">
            <path
              d="M8.45728 2.66904C8.60418 2.52192 8.71467 2.35638 8.78794 2.17243C8.86161 1.9887 8.89844 1.79936 8.89844 1.60507C8.89844 1.41056 8.86161 1.21875 8.78794 1.02961C8.71428 0.840481 8.6042 0.672482 8.45728 0.525345C8.16262 0.231105 7.81085 0.0839844 7.40073 0.0839844C6.99145 0.0839844 6.63885 0.231105 6.34502 0.525345L0.497413 6.42033C0.350088 6.54656 0.24498 6.70671 0.182055 6.90122C0.118738 7.09554 0.0926619 7.29791 0.103433 7.50792C0.113354 7.71815 0.160955 7.92549 0.244964 8.13034C0.328972 8.33561 0.444426 8.51151 0.591766 8.65841L6.34502 14.4588C6.63926 14.7638 6.99145 14.9161 7.40073 14.9161C7.81087 14.9161 8.16263 14.7638 8.45728 14.4588C8.60418 14.3119 8.71467 14.1464 8.78794 13.9626C8.86161 13.7789 8.89844 13.5893 8.89844 13.3952C8.89844 13.2007 8.86161 13.0087 8.78794 12.82C8.71467 12.6309 8.6042 12.4625 8.45728 12.3151L3.69684 7.49217L8.45728 2.66904Z"
              fill="#EA3928" />
          </svg>
          <span style="margin-left: 10px;">返回</span>
        </div>
        <div style="padding: 10px 0 10px 20px;font-size: 17px;">
          <!--            <div style="margin-bottom: 10px;">目录</div>-->

          <div v-for="(item, index) in list" :key="index">
            <!-- <div v-if="item.headLine == '财务诊断'" style="display: none;"></div> -->
            <div v-if="item.horizontalLabels == null || item.horizontalLabels.length == 0" style="margin-bottom: 10px;">
              <!-- <a style="text-decoration: none;color: #222;" @click="retract(null)" :href="'#box-' + item.blockIndex">{{ item.headLine }}</a> -->
              <div style="cursor: pointer;color: #222;" @click="retract(null); moveToId('#box-' + item.blockIndex);">{{
                item.headLine }}</div>
            </div>
            <div v-else class="buttons-box">
              <div class="buttons-box-header" @click="retract($event)">
                <!-- <a style="text-decoration: none;color: #222;" :href="'#box-' + item.blockIndex">{{ item.headLine }}</a> -->
                <div style="cursor: pointer;color: #222;" @click="moveToId('#box-' + item.blockIndex)">{{ item.headLine }}
                </div>
                <img src="../../../../static/img/down.png" style="transform: rotate(0deg);">
              </div>
              <div class="buttons-box-retract">
                <div class="buttons-box-retract-box">
                  <div class="buttons-item" v-for="(item2, index2) in item.horizontalLabels" :key="index2">
                    <div v-if="item.resultType == 20" @click="assess(item2.iconType)">{{ item2.labelName }}</div>
                    <div v-else @click="viewAnaInfos(getHorizontalLabelsOfSonData(item2))">{{ item2.labelName }}</div>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div class="right-content" style="width: 1000px;">

        <div style="display: flex;align-items: center;margin-bottom: -20px;">
          <div style="margin-left: 30px;margin-right: 20px;font-size: 18px;font-weight: 600;">{{ name }}</div>
          <div>
            <el-dropdown trigger="click" @command="changeReport">
              <span class="el-dropdown-link" style="cursor: pointer;color: #EA3928;">
                {{ checkYear + '年' + checkStage + '分析' }}<i class="el-icon-arrow-down el-icon--right"></i>
              </span>
              <el-dropdown-menu slot="dropdown">
                <el-dropdown-item v-for="(item, index) in reprotlist" :key="index" :command="item">{{
                  item.year + '年' + item.stage }}</el-dropdown-item>
              </el-dropdown-menu>
            </el-dropdown>
          </div>
          <div style="flex: 1;"></div>
          <div style="display: flex;align-items: center;">
            <img :src="getIconUrl('0')" style="width: 68px;margin-right: 5px;max-width: none;margin-bottom: 0;">
            <span style="color: #EA3928;cursor: pointer;" @click="analysisReport">财务分析报告 ></span>
          </div>
        </div>

        <div class="content-son-box" v-for="(item, index) in list" :key="index" :id="'box-' + item.blockIndex">
          <div style="display: flex;align-items: center;">
            <div style="width: 3px;height: 30px;background-color: #EA3928;margin-right: 5px;"></div>
            <span style="font-size: 17px;font-weight: 700;">{{ item.headLine }}</span>
          </div>

          <!-- 评估模型 -->
          <div v-if="item.resultType == 20">
            <div style="display: flex;justify-content: space-around;">
              <div style="display: flex;flex-direction: column;align-items: center;margin-top: 8px;"
                v-for="(item2, index2) in item.horizontalLabels" :key="index2">
                <img :src="getIconUrl(item2.iconType)" @click="assess(item2.iconType)"
                  style="width: 42px;cursor: pointer;">
                <span @click="assess(item2.iconType)" style="cursor: pointer;color: #595959;">{{ item2.labelName }}</span>
              </div>
            </div>
          </div>

          <!-- 营业收入 -->
          <div v-if="item.resultType == 2">
            <div style="display: flex;justify-content: flex-start;margin-bottom: 10px;">
              <div
                style="display: flex;flex-direction: column;align-items: center;margin-top: 8px;max-width: 140px;text-align: center;margin-right: 15px;"
                v-for="(item2, index2) in item.horizontalLabels" :key="index2">
                <img @click="viewAnaInfos(getHorizontalLabelsOfSonData(item2))" :src="getIconUrl(item2.iconType)"
                  style="width: 42px;cursor: pointer;">
                <span @click="viewAnaInfos(getHorizontalLabelsOfSonData(item2))" class="text-over"
                  style="cursor: pointer;color: #595959;">{{
                    item2.labelName }}</span>
              </div>
            </div>
            <div style="margin-bottom: 10px;">
              <div style="display: flex;border: 1px solid #EA3928;width: max-content;margin: 0 auto;">
                <template v-for="(item2, index2) in item.showAna[0].data.chartNameList">
                  <div :key="'s-' + index2" v-if="selectedIndex2 == index2" class="normal-box-selected">{{ item2 }}</div>
                  <div :key="'n-' + index2" v-else class="normal-box"
                    @click="changeSelect2(index2, item.showAna[0].data.chartDataList[index2], item.showAna[0].data.tableList[index2])">
                    {{ item2 }}</div>
                </template>
              </div>
              <div class="showAna">
                <div id="echarts-showAna" style="width: 100%;height: 300px;"></div>
              </div>
              <div>
                <table cellspacing="0">
                  <thead>
                    <tr>
                      <th v-for="(head, index2) in showAnaTableTemp.head" :key="index2">{{ head }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(body, index2) in showAnaTableTemp.body" :key="index2">
                      <td v-for="(bodyItem, index3) in body" :key="index3">{{ bodyItem }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- 总体分析 -->
          <div v-if="item.resultType == 3">
            <div style="display: flex;justify-content: space-around;margin-bottom: 20px;margin-top: 20px;">
              <div style="margin-left: 30px;margin-right: 10px;">{{ fenshu.rank }}</div>
              <div style="margin-left: 30px;margin-right: 10px;">{{ fenshu.industryRank }}</div>
              <div style="flex: 1;"></div>
              <div v-for="(item2, index2) in item.startBlock.horizontalLabels" :key="index2"
                @click="viewAnaInfos(getHorizontalLabelsOfSonData(item2))"
                style="margin-left: 10px;margin-right: 30px;color: #999;cursor: pointer;">
                {{ item2.labelName }} >
              </div>
            </div>
            <!-- <div v-if="fenshu.industryTable != null" style="margin-bottom: 10px;">
              <table cellspacing="0">
                <thead>
                  <tr>
                    <th v-for="(head, index2) in fenshu.industryTable.data.head" :key="index2">{{ head }}</th>
                  </tr>
                </thead>
                <tbody>
                  <tr v-for="(body, index2) in fenshu.industryTable.data.body" :key="index2">
                    <td v-for="(bodyItem, index3) in body" :key="index3">{{ bodyItem }}</td>
                  </tr>
                </tbody>
              </table>
            </div> -->
            <!-- <div style="display: flex;justify-content: space-evenly;margin-bottom: 10px;">
              <div v-for="(item2, index2) in item.startBlock.horizontalLabels" :key="index2">
                <el-button type="info" style="color: #000;background-color: #ededed;"
                  @click="viewAnaInfos(getHorizontalLabelsOfSonData(item2))">{{ item2.labelName }}</el-button>
              </div>
            </div> -->
            <div style="display: flex;justify-content: space-evenly;align-items: center;margin-bottom: 10px;">
              <div style="display: flex;flex-direction: column;align-items: center;"
                v-for="(item2, index2) in item.startBlock.indicators" :key="index2">
                <div style="margin-bottom: 10px;">{{ item2.valStr }}</div>
                <div style="margin-bottom: 10px;color: #EA3928;" v-if="item2.growthRate >= 0">{{ toRate(item2.growthRate) }}</div>
                <div style="margin-bottom: 10px;color: green;" v-else>{{ toRate(item2.growthRate) }}</div>
                <div style="margin-bottom: 10px;" v-if="selectedIndex3 == index2" class="normal-button-selected">{{ item2.labelName }}</div>
                <div style="margin-bottom: 10px;" v-else class="normal-button" @click="changeSelect3(index2, item2.showInfos[0].data)">{{
                  item2.labelName }}</div>
              </div>
            </div>
            <div class="indicators" style="margin-bottom: 10px;">
              <div id="echarts-indicators" style="width: 100%;height: 300px;"></div>
            </div>
          </div>

          <!-- 利润，资产负债，现金流，同行业比较情况 -->
          <div v-if="item.resultType == 4">

            <div v-if="item.headLine == '利润'" @click="viewProfitData()"
              style="display: inline-block;position: relative;top: -30px;left: 60px;float: left;margin-right: -74px;padding: 5px;background-color: #f6e2e3;color: #EA3928;border-radius: 5px;cursor:pointer;">
              利润评价
            </div>

            <div style="display: flex;justify-content: flex-start;margin-bottom: 10px;">
              <div
                style="display: flex;flex-direction: column;align-items: center;margin-top: 8px;max-width: 140px;text-align: center;margin-right: 15px;"
                v-for="(item2, index2) in item.horizontalLabels" :key="index2">
                <img @click="viewAnaInfos(getHorizontalLabelsOfSonData(item2))" :src="getIconUrl(item2.iconType)"
                  style="width: 42px;cursor: pointer;">
                <span @click="viewAnaInfos(getHorizontalLabelsOfSonData(item2))" class="text-over"
                  style="cursor: pointer;color: #595959;">{{
                    item2.labelName }}</span>
              </div>
            </div>

            <div style="margin-bottom: 10px;" v-if="item.headLine == '利润' && psList != null">
              <div>
                <table cellspacing="0">
                  <thead>
                    <tr>
                      <th>科目名称</th>
                      <th>本期值</th>
                      <th>同比增长率</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(body, index2) in psList.noNote" :key="'d1' + index2">
                      <td>{{ body.subjectMean }}</td>
                      <td>{{ body.subjectAmount }}</td>
                      <td>{{ body.yearOnYear }}</td>
                    </tr>
                    <tr v-for="(body, index2) in psList.hasNote" :key="'d2' + index2">
                      <td class="td-click" @click="viewHasNote(body)">{{ body.subjectMean }}</td>
                      <td>{{ body.subjectAmount }}</td>
                      <td>{{ body.yearOnYear }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div style="margin-bottom: 10px;" v-if="item.headLine == '资产负债' && bsList != null">
              <div>
                <table cellspacing="0">
                  <thead>
                    <tr>
                      <th>科目名称</th>
                      <th>本期值</th>
                      <th>同比增长率</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(body, index2) in bsList.noNote" :key="'d1' + index2">
                      <td>{{ body.subjectMean }}</td>
                      <td>{{ body.subjectAmount }}</td>
                      <td>{{ body.yearOnYear }}</td>
                    </tr>
                    <tr v-for="(body, index2) in bsList.hasNote" :key="'d2' + index2">
                      <td class="td-click" @click="viewHasNote(body)">{{ body.subjectMean }}</td>
                      <td>{{ body.subjectAmount }}</td>
                      <td>{{ body.yearOnYear }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div style="margin-bottom: 10px;" v-if="item.headLine == '现金流' && cfsList != null">
              <div>
                <table cellspacing="0">
                  <thead>
                    <tr>
                      <th>科目名称</th>
                      <th>本期值</th>
                      <th>同比增长率</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(body, index2) in cfsList.noNote" :key="'d1' + index2">
                      <td>{{ body.subjectMean }}</td>
                      <td>{{ body.subjectAmount }}</td>
                      <td>{{ body.yearOnYear }}</td>
                    </tr>
                    <tr v-for="(body, index2) in cfsList.hasNote" :key="'d2' + index2">
                      <td class="td-click" @click="viewHasNote(body)">{{ body.subjectMean }}</td>
                      <td>{{ body.subjectAmount }}</td>
                      <td>{{ body.yearOnYear }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div style="margin-bottom: 10px;"
              v-if="item.headLine == '财务诊断' && item.showAna != null && item.showAna.length > 0">
              <div>
                <div style="display: flex;">
                  <div style="width: 200px;margin-left: 30px;">
                    <div style="margin-top: 50px;color: #666;">财务总评分:</div>
                    <div style="margin-bottom: 30px;">
                      <span style="font-size: 20px;">{{ item.showAna[0].data.fraction }}</span>
                      <span>/5 </span>
                      <span style="color: #ee2832;" v-if="item.showAna[0].data.scorechanges > 0">
                        <i class="el-icon-caret-top"></i>
                        {{ item.showAna[0].data.scorechanges }}
                      </span>
                      <span style="color: #0aa64c;" v-if="item.showAna[0].data.scorechanges < 0">
                        <i class="el-icon-caret-bottom"></i>
                        {{ -1 * item.showAna[0].data.scorechanges }}
                      </span>
                    </div>
                    <div style="color: #666;">行业排名: <span style="color: #000;">{{ item.showAna[0].data.industryranking
                    }}</span></div>
                    <div style="color: #666;">所属行业: <span style="color: #0074e0;">{{ item.showAna[0].data.industryname
                    }}</span></div>
                  </div>
                  <div style="width: calc(100% - 200px);">
                    <div style="display: none;">{{ drawECharts('echarts-diagnosis', item.showAna[0].data.radarchart) }}
                    </div>
                    <div id="echarts-diagnosis" style="height: 300px;"></div>
                  </div>
                </div>
              </div>
            </div>

            <div style="margin-bottom: 10px;"
              v-if="item.headLine == '同业比较情况' && item.showAna != null && item.showAna.length > 0">
              <div>
                <table cellspacing="0">
                  <thead>
                    <tr>
                      <th v-for="(head, index2) in item.showAna[0].data.head" :key="'h' + index2">{{ head }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(body, index2) in item.showAna[0].data.body" :key="'d' + index2">
                      <td v-for="(bodyItem, index3) in body" :key="index3">{{ bodyItem }}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

          </div>

        </div>

      </div>


    </div>

  </div>
</template>
    
<script>
import * as echarts from "echarts";
import { linkName, sendRequestIndustry, sendRequestCompany2, sendRequestCompanyLocation } from '../../../../static/js/util';
import dubang from './dubang.vue';
import wallRating from './wallRating.vue';
import zValue from './zValue.vue';
import mValue from './mValue.vue';
import fValue from './fValue.vue';
import anaInfos from './anaInfos.vue';

export default {
  components: {
    dubang,
    wallRating,
    zValue,
    mValue,
    fValue,
    anaInfos
  },
  data() {
    return {
      comCode: '',
      name: '',
      list: [],
      titleList: [],
      fenshu: {},
      fenshuInfo: {},
      reprotlist: [],
      reportScroll: {},
      checkYear: '----',
      checkStage: '--',
      selectedIndex2: 0,
      showAnaTableTemp: [],
      selectedIndex3: 0,

      dubangShow: false,
      wallRatingShow: false,
      zValueShow: false,
      mValueShow: false,
      fValueShow: false,

      anaInfosShow: false,
      anaType: 0,
      anaData: null,

      psList: null,  //利润
      bsList: null,  //资产负债
      cfsList: null,  //现金流

    };
  },
  mounted() {
    this.comCode = this.$route.query.comCode;
    this.name = this.$route.query.comName;

    window.parent.onscroll = () => {
      var scrollHeight = window.parent.scrollY;
      if (scrollHeight > 90) {
        $('#left-menu').css({ top: scrollHeight - 90 + 'px' });
      } else {
        $('#left-menu').css({ top: '0px' });
      }
    }

    this.getData();
  },
  methods: {
    back() {
      linkName(this, 'companyResearch');
    },
    moveToId(idStr) {
      document.querySelector(idStr).scrollIntoView({
        behavior: "smooth"
      });
    },
    retract(event) {
      // console.log(event)
      // console.log(event.parentElement.children)

      //全收起
      $('.buttons-box-header > img').css({ transform: 'rotate(0deg)' });
      $('.buttons-box-retract').css({ 'grid-template-rows': '0fr' });

      if (event != null) {
        var element;
        if (event.srcElement.className == 'buttons-box-header') {
          element = event.srcElement;
        } else {
          element = event.srcElement.parentElement;
        }

        if (element.parentElement.children[1].style.gridTemplateRows === "0fr") {
          element.parentElement.children[1].style.gridTemplateRows = "1fr";
          element.children[1].style.transform = "rotate(180deg)";
        } else {
          element.parentElement.children[1].style.gridTemplateRows = "0fr";
          element.children[1].style.transform = "rotate(0deg)";
        }
      }
    },
    getData() {
      let url = '/company/selfOneComNew?code=' + this.comCode;
      sendRequestIndustry(url, 'get', null, response => {
        if (response.data.code === 0) {
          this.reprotlist = response.data.data.comInfoDTO.comReports;
          this.checkYear = response.data.data.year;
          this.checkStage = response.data.data.stage;
          this.getAnalysisResult(this.comCode, response.data.data.year, response.data.data.stage)
          this.getFenshu(this.comCode, response.data.data.year, response.data.data.stage)
          this.getTable(this.comCode, response.data.data.year, response.data.data.stage);
        } else if (response.data.code === 1) {
          this.$alert(response.data.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {
              window.history.back();
            }
          });
        } else {
          this.$alert('分析报告未出', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              window.history.back();
            }
          });
        }
      }, error => {
        console.log(error);
      })
    },
    getAnalysisResult(comCode, year, stage) {
      const loading = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(255, 255, 255, 0.7)'
      });

      // /company/report/reportFinance/600300/0
      let url = '/company/analysisResult/' + comCode + '/' + year + '/' + stage;
      sendRequestIndustry(url, 'get', null, response => {
        loading.close();
        if (response.data.code == 1 || response.data.code == 11041 || response.data.code == 11051) {
          this.$alert(response.data.msg, '提示', {
            confirmButtonText: '确定',
            callback: action => {
              window.history.back();
            }
          });
        } else if (response.data.code == 5001 || response.data.code == 5002) {
          this.$alert('您的查看次数已用完，成为VIP即享碧湾所有分析数据', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              window.history.back();
            }
          });
        } else if (response.data.code == 0) {
          if (response.data.data != null) {
            this.list = response.data.data[0].anaBlockAllResult.anaBlockResults;
            this.titleList = response.data.data[0].anaBlockAllResult.anaBlockBarNames;


            for (var i = 0; i < this.list.length; i++) {
              //营业收入第一项
              if (this.list[i].resultType == 2) {
                this.drawECharts('echarts-showAna', this.list[i].showAna[0].data.chartDataList[0]);
                this.showAnaTableTemp = this.list[i].showAna[0].data.tableList[0];
              }
              //加载总体分析的第一张图
              if (this.list[i].resultType == 3) {
                this.drawECharts('echarts-indicators', this.list[i].startBlock.indicators[0].showInfos[0].data);
              }
            }

          } else {
            this.$alert('分析报告未出', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                window.history.back();
              }
            });
          }
        } else if (response.data.code == 11011 || response.data.code == 11012) {
          if (!isLogin) {
            this.$alert('请登录后查看', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                window.history.back();
              }
            });
          } else {
            this.$alert('请重新登录', '提示', {
              confirmButtonText: '确定',
              callback: action => {
                window.history.back();
              }
            });
          }
        } else {
          this.$alert('分析报告未出', '提示', {
            confirmButtonText: '确定',
            callback: action => {
              window.history.back();
            }
          });
        }

      }, error => {
        loading.close();
        console.log(error);
      })
    },
    getFenshu(comCode, year, stage) {
      let url = '/report/scoreReport/' + comCode + '/' + year + '/' + stage;
      sendRequestCompany2(url, 'get', null, response => {
        if (response.data.code == 1) {

        } else if (response.data.code == 0) {
          this.fenshu = JSON.parse(response.data.data.resultJson);
          // console.log(JSON.parse(response.data.resultJson).industryTable);
          // console.log(JSON.parse(response.data.data.resultJson))
        }
      }, error => {
        console.log(error);
      })
    },
    getTable(comCode, year, stage) {
      var type = 0;
      if ('年报' === stage) {
        type = 0;
      } else if ('一季报' === stage) {
        type = 1;
      } else if ('中报' === stage) {
        type = 2;
      } else if ('三季报' === stage) {
        type = 3;
      }
      let url = '/primaryTablesEcharts/getInfoByCondition?orgCode=' + comCode + '&pdfYear=' + year + '&pdfType=' + type;
      sendRequestCompanyLocation(url, 'get', null, response => {
        // console.log(response.data)
        if (response.data.flag == 0) {
          this.psList = response.data.data.psList;
          this.bsList = response.data.data.bsList;
          this.cfsList = response.data.data.cfsList;
        }
      }, error => {
        console.log(error);
      })
    },
    changeReport(row) {
      this.checkYear = row.year;
      this.checkStage = row.stage;

      this.getAnalysisResult(this.comCode, this.checkYear, this.checkStage);
      this.getFenshu(this.comCode, this.checkYear, this.checkStage);
    },
    analysisReport() {
      window.open('/beawanHome/companyResearch/analysisReport?comCode=' + this.comCode + '&year=' + this.checkYear + '&type=' + this.checkStage);
    },
    getIconUrl(iconType) {

      if (process.env.NODE_ENV === 'production') {
        switch (iconType) {
          case '0':
            return '/beawanHome/static/img/finance.png'
          case '1':
            return '/beawanHome/static/img/research/jlr.png'
          case '2':
            return '/beawanHome/static/img/research/fjcxsy.png'
          case '3':
            return '/beawanHome/static/img/research/hxlr.png'
          case '4':
            return '/beawanHome/static/img/research/tz.png'
          case '5':
            return '/beawanHome/static/img/research/zcjz.png'
          case '6':
            return '/beawanHome/static/img/research/jrtz.png'
          case '7':
            return '/beawanHome/static/img/research/cqgqtz.png'
          case '8':
            return '/beawanHome/static/img/research/sy.png'
          case '9':
            return '/beawanHome/static/img/research/zjgc.png'
          case '10':
            return '/beawanHome/static/img/research/gjzc.png'
          case '11':
            return '/beawanHome/static/img/research/ch.png'
          case '12':
            return '/beawanHome/static/img/research/yszk.png'
          case '13':
            return '/beawanHome/static/img/research/srlr.png'
          case '14':
            return '/beawanHome/static/img/research/lrxjl.png'
          case '15':
            return '/beawanHome/static/img/research/sdzb.png'
          case '16':
            return '/beawanHome/static/img/research/zcfzl.png'
          case '17':
            return '/beawanHome/static/img/research/zckmbh.png'
          case '18':
            return '/beawanHome/static/img/research/jyhdxjl.png'
          case '19':
            return '/beawanHome/static/img/research/tzhdxjl.png'
          case '20':
            return '/beawanHome/static/img/research/czhdxjl.png'

          case '21':
            return '/beawanHome/static/img/research/dbfx.png'
          case '22':
            return '/beawanHome/static/img/research/oepf.png'
          case '23':
            return '/beawanHome/static/img/research/zzyj.png'
          case '24':
            return '/beawanHome/static/img/research/mzyj.png'
          case '25':
            return '/beawanHome/static/img/research/fzyj.png'


          case '40':
            return '/beawanHome/static/img/research/ysbh.png'
          case '41':
            return '/beawanHome/static/img/research/cpyszbbh.png'
          case '42':
            return '/beawanHome/static/img/research/gnwxsqk.png'
          case '43':
            return '/beawanHome/static/img/research/qwdshkhbzbh.png'
          case '44':
            return '/beawanHome/static/img/research/fyqk.png'


          case '71':
            return '/beawanHome/static/img/research/xsjll.png'
          case '72':
            return '/beawanHome/static/img/research/jlrzzl.png'
          case '73':
            return '/beawanHome/static/img/research/jqjzcsyl.png'
          case '74':
            return '/beawanHome/static/img/research/yszkzzl.png'
          case '75':
            return '/beawanHome/static/img/research/chzzl.png'
          case '76':
            return '/beawanHome/static/img/research/ldbl.png'
          case '77':
            return '/beawanHome/static/img/research/sdbl.png'
          case '78':
            return '/beawanHome/static/img/research/zcfzl.png'


          case '81':
            return '/beawanHome/static/img/research/yinglinengli.png'
          case '82':
            return '/beawanHome/static/img/research/chengzhangnengli.png'
          case '83':
            return '/beawanHome/static/img/research/yunyingnengli.png'
          case '84':
            return '/beawanHome/static/img/research/cznl.png'
          case '85':
            return '/beawanHome/static/img/research/xianjinliu.png'


          case '1001':
            return '/beawanHome/static/img/research/cwfxbg.png'
          case '1002':
            return '/beawanHome/static/img/research/dcbg.png'


          default:
            return ''
        }
      } else {
        switch (iconType) {
          case '0':
            return '../../../../static/img/finance.png'
          case '1':
            return '../../../../static/img/research/jlr.png'
          case '2':
            return '../../../../static/img/research/fjcxsy.png'
          case '3':
            return '../../../../static/img/research/hxlr.png'
          case '4':
            return '../../../../static/img/research/tz.png'
          case '5':
            return '../../../../static/img/research/zcjz.png'
          case '6':
            return '../../../../static/img/research/jrtz.png'
          case '7':
            return '../../../../static/img/research/cqgqtz.png'
          case '8':
            return '../../../../static/img/research/sy.png'
          case '9':
            return '../../../../static/img/research/zjgc.png'
          case '10':
            return '../../../../static/img/research/gjzc.png'
          case '11':
            return '../../../../static/img/research/ch.png'
          case '12':
            return '../../../../static/img/research/yszk.png'
          case '13':
            return '../../../../static/img/research/srlr.png'
          case '14':
            return '../../../../static/img/research/lrxjl.png'
          case '15':
            return '../../../../static/img/research/sdzb.png'
          case '16':
            return '../../../../static/img/research/zcfzl.png'
          case '17':
            return '../../../../static/img/research/zckmbh.png'
          case '18':
            return '../../../../static/img/research/jyhdxjl.png'
          case '19':
            return '../../../../static/img/research/tzhdxjl.png'
          case '20':
            return '../../../../static/img/research/czhdxjl.png'

          case '21':
            return '../../../../static/img/research/dbfx.png'
          case '22':
            return '../../../../static/img/research/oepf.png'
          case '23':
            return '../../../../static/img/research/zzyj.png'
          case '24':
            return '../../../../static/img/research/mzyj.png'
          case '25':
            return '../../../../static/img/research/fzyj.png'


          case '40':
            return '../../../../static/img/research/ysbh.png'
          case '41':
            return '../../../../static/img/research/cpyszbbh.png'
          case '42':
            return '../../../../static/img/research/gnwxsqk.png'
          case '43':
            return '../../../../static/img/research/qwdshkhbzbh.png'
          case '44':
            return '../../../../static/img/research/fyqk.png'


          case '71':
            return '../../../../static/img/research/xsjll.png'
          case '72':
            return '../../../../static/img/research/jlrzzl.png'
          case '73':
            return '../../../../static/img/research/jqjzcsyl.png'
          case '74':
            return '../../../../static/img/research/yszkzzl.png'
          case '75':
            return '../../../../static/img/research/chzzl.png'
          case '76':
            return '../../../../static/img/research/ldbl.png'
          case '77':
            return '../../../../static/img/research/sdbl.png'
          case '78':
            return '../../../../static/img/research/zcfzl.png'


          case '81':
            return '../../../../static/img/research/yinglinengli.png'
          case '82':
            return '../../../../static/img/research/chengzhangnengli.png'
          case '83':
            return '../../../../static/img/research/yunyingnengli.png'
          case '84':
            return '../../../../static/img/research/cznl.png'
          case '85':
            return '../../../../static/img/research/xianjinliu.png'


          case '1001':
            return '../../../../static/img/research/cwfxbg.png'
          case '1002':
            return '../../../../static/img/research/dcbg.png'


          default:
            return ''
        }
      }

    },
    //评估模型
    assess(iconType) {
      var url = 'about:blank';
      if (iconType === '21') {
        this.dubangShow = true;
      } else if (iconType === '22') {
        this.wallRatingShow = true;
      } else if (iconType === '23') {
        this.zValueShow = true;
      } else if (iconType === '24') {
        this.mValueShow = true;
      } else if (iconType === '25') {
        this.fValueShow = true;
      }

    },
    getHorizontalLabelsOfSonData(data) {
      if (data.labelType == 1) {
        if (data.showInfos == null) {
          return data.anaInfos;
        } else if (data.showInfos.length == 0) {
          return data.anaInfos;
        } else {
          return data.showInfos;
        }
      } else if (data.labelType == 2) {
        return data.anaInfos;
      } else if (data.labelType == 3) {
        return data.showInfos;
      } else if (data.labelType == 4) {
        return data.anaBlockResults[0].mainBody;
      } else {
        return data.anaInfos;
      }
    },
    viewAnaInfos(data) {
      // this.anaInfosTemp = data;
      // this.anaInfosShow = true;
      //
      // //清除echarts图
      // $('.anaInfos div[_echarts_instance_]').html("");
      // $('.anaInfos div[_echarts_instance_]').removeAttr("_echarts_instance_");
      //
      // for(var i=0; i<data.length; i++){
      //     if(data[i].type==3){
      //         this.drawECharts('echarts-anaInfos-'+i, data[i].data);
      //     }
      // }

      // window.parent.researchVue.viewAnaInfos(data);

      this.anaType = 1;
      this.anaData = data;
      this.anaInfosShow = true;
    },
    viewProfitData() {
      let url = '/company/profitDataNoLoginPlus/' + this.comCode;
      sendRequestCompany2(url, 'get', null, response => {
        // console.log(response.data)
        if (response.data.code == 0) {
          // window.parent.researchVue.viewProfitInfo(response.data.data);
          this.anaType = 2;
          this.anaData = response.data.data;
          this.anaInfosShow = true;
        }
      }, error => {
        console.log(error);
      })
    },
    viewHasNote(row) {
      // console.log(row);
      let url = '/primaryTablesEcharts/getSingleInfo' +
        '?orgCode=' + row.orgCode +
        '&pdfYear=' + row.pdfYear +
        '&pdfType=' + row.pdfType +
        '&tableType=' + row.tableType +
        '&subjectMean=' + row.subjectMean;
      sendRequestCompanyLocation(url, 'get', null, response => {
        // console.log(response.data)
        if (response.data.flag == 0) {
          // window.parent.researchVue.viewSingleInfo(response.data.data);
          this.anaType = 3;
          this.anaData = response.data.data;
          this.anaInfosShow = true;
        }
      }, error => {
        console.log(error);
      })
    },
    //画echarts图
    drawECharts(idName, data) {
      setTimeout(() => {
        // console.log(idName)
        var chartDom = document.getElementById(idName);
        var myChart = echarts.init(chartDom);
        var option = JSON.parse(data);
        option && myChart.setOption(option);
      }, 300)
    },
    toRate(num) {
      num = parseFloat(num)
      if (isNaN(num)) {
        return '-';
      } else {
        return num.toFixed(2) + '%';
      }
    },
    //金额单位转万元
    toMoney(num) {
      var minus = 1;
      if (num < 0) {
        minus = -1;
        num = num * -1;
      }
      if (num < 10000) {
        return minus * num;
      } else if (num < 100000000) {
        var temp = num / 10000;
        return minus * temp.toFixed(2) + ' 万';
      } else {
        var temp = num / 100000000;
        return minus * temp.toFixed(2) + ' 亿';
      }
    },
    changeSelect2(sign, echartsData, tableData) {
      this.selectedIndex2 = sign;
      //清除echarts图
      $('.showAna div[_echarts_instance_]').html("");
      $('.showAna div[_echarts_instance_]').removeAttr("_echarts_instance_");

      this.drawECharts('echarts-showAna', echartsData);
      this.showAnaTableTemp = tableData;
    },
    changeSelect3(sign, data) {
      this.selectedIndex3 = sign;
      //清除echarts图
      $('.indicators div[_echarts_instance_]').html("");
      $('.indicators div[_echarts_instance_]').removeAttr("_echarts_instance_");

      this.drawECharts('echarts-indicators', data);
    }
  }
};
</script>
    
<style scoped>
.right-content img {
  max-width: 30px;
  margin-bottom: 10px;
}

.buttons-box-header {
  display: flex;
  margin-bottom: 10px;
  align-items: center;
}

.buttons-box-header>span {
  font-size: 17px;
  cursor: pointer;
}

.buttons-box-header>img {
  width: 8px;
  height: 8px;
  margin-left: 5px;
  cursor: pointer;
}

.buttons-box-retract {
  display: grid;
  overflow: hidden;
  transition: 0.5s;
  grid-template-rows: 0fr;
}

.buttons-box-retract-box {
  min-height: 0px;
  display: flex;
  flex-direction: column;
  flex-wrap: nowrap;
}

.buttons-item {
  /* height: 80px; */
  /* padding-left: 50px; */
  /* width: calc(20% - 50px); */
  margin-bottom: 10px;
  color: #999;
  font-size: 15px;
  cursor: pointer;
  margin-left: 15px;
}

/*.buttons-item > div {*/
/*    height: 100%;*/
/*    display: flex;*/
/*    justify-content: flex-start;*/
/*    align-items: center;*/
/*    flex-wrap: wrap;*/
/*    align-content: center;*/
/*}*/

/*.buttons-item img {*/
/*    width: 22px;*/
/*    margin-right: 10px;*/
/*    !*cursor: pointer;*!*/
/*}*/

/*.buttons-item span {*/
/*    cursor: pointer;*/
/*}*/

/*.buttons-item p {*/
/*    font-size: 13px;*/
/*    color: #555;*/
/*    margin: 4px 0 0 0;*/
/*    cursor: pointer;*/
/*}*/


/* .el-dropdown-menu__item:not(.is-disabled):hover {
  background-color: #F8E8E9;
  color: #EA3928;
} */

table {
  width: calc(100% - 200px);
  text-align: center;
  border-top: 1px solid #f2887e;
  border-left: 1px solid #f2887e;
  margin: 0 100px;
}

th,
td {
  line-height: 30px;
}

/* th {
  background-color: #e6e6e6;
} */

th,
td {
  border-bottom: 1px solid #f2887e;
  border-right: 1px solid #f2887e;
}

.td-click {
  color: #0770c4;
  cursor: pointer;
}

/* .el-dialog__headerbtn {
  top: 7px;
  right: 10px;
} */

/* .el-dialog__body {
  padding: 0 10px 10px 10px;
  color: #000;
  height: 500px;
  overflow: auto;
} */

.normal-button {
  background-color: #F0F2F4;
  color: #000;
  padding: 7px 10px;
  border-radius: 5px;
  cursor: pointer;
}

.normal-button-selected {
  background-color: #f6e2e3;
  color: #EA3928;
  padding: 7px 10px;
  border-radius: 5px;
}

.normal-box {
  background-color: #fff;
  color: #999;
  padding: 4px 20px;
  cursor: pointer;
}

.normal-box-selected {
  background-color: #EA3928;
  color: #fff;
  padding: 4px 20px;
}

.content-son-box {
  margin-top: 30px;
  background-color: #fff;
  padding: 10px;
  border-radius: 5px;
}

.text-over {
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
}
</style>